import React, { Component, Fragment } from 'react';
import MenuLayout from '../Menu/Layout';
import HeaderLayout from '../Header/Layout';


class AppLayout extends Component {
    render() {
        var style = {
            opacity: 1
        }
        return (
            <div id="wrap" style={style} className="animsition">
                {
                    (sessionStorage.getItem('token')) ?
                        <Fragment>
                            <HeaderLayout />
                            <MenuLayout />
                            {this.props.children}
                        </Fragment> :
                        window.location.href = '/'
                }
            </div>
        );
    }
}

export default AppLayout;


// WEBPACK FOOTER //
// ./src/Components/Content/AuthenticatedLayout.js